export const SCHOOL_LEVELS = [
  '',
  '유치원',
  '초등학교',
  '중학교',
  '고등학교',
  '특수학교',
  '기타',
];

/**
 * 나이스 학교 종류(SCHUL_KND_SC_NM) → 학교급 선택값.
 * "각종학교(고)", "방송통신고등학교" 같은 변형은 이름에 든 학교급으로 맞추고,
 * 그래도 모르면 '기타'. 빈 값이면 '' (호출 쪽에서 기존 값 유지).
 */
export const schoolLevelFromKind = (kind) => {
  const text = String(kind || '').trim();
  if (!text) return '';
  if (SCHOOL_LEVELS.includes(text)) return text;
  if (text.includes('유치원')) return '유치원';
  if (text.includes('초등')) return '초등학교';
  if (text.includes('고등') || text.includes('(고)')) return '고등학교';
  if (text.includes('중학') || text.includes('(중)')) return '중학교';
  if (text.includes('특수')) return '특수학교';
  return '기타';
};
